import styled from 'styled-components';

export const RadioButtonContainer = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.commons.radioButton.background};
  border: solid 1px ${props => props.theme.commons.radioButton.borderColor};

  ${props =>
    props.selected &&
    `background-color: ${props.theme.commons.radioButton.selectedColor};
`}
  ${props =>
    props.disabled &&
    `border-color: ${props.theme.commons.radioButton.disabled};
`}
`;
